export const guestFields = [
	{ name: 'firstName', label: 'enums.Guest.guestFields.firstName' },
	{ name: 'lastName', label: 'enums.Guest.guestFields.lastName' },
	{ name: 'email', label: 'enums.Guest.guestFields.email' },
	{ name: 'phone', label: 'enums.Guest.guestFields.phone' },
	{ name: 'street', label: 'enums.Guest.guestFields.street' },
	{ name: 'city', label: 'enums.Guest.guestFields.city' },
	{ name: 'postCode', label: 'enums.Guest.guestFields.postCode' },
	{ name: 'note', label: 'enums.Guest.guestFields.note', textarea: true, required: false },
];

export const companyFields = [
	{ name: 'companyName', label: 'enums.Guest.companyFields.name' },
	{ name: 'companyIc', label: 'enums.Guest.companyFields.ic' },
	{ name: 'companyDic', label: 'enums.Guest.companyFields.dic', required: false },
	{ name: 'companyStreet', label: 'enums.Guest.companyFields.street' },
	{ name: 'companyCity', label: 'enums.Guest.companyFields.city' },
	{ name: 'companyPostCode', label: 'enums.Guest.companyFields.postCode' },
	{ name: 'companyCountry', label: 'enums.Guest.companyFields.country' },
];

export default {
	guestFields,
	companyFields,
}


// WEBPACK FOOTER //
// ./src/enums/Guest.js